module.exports = __webpack_public_path__ + "img/audio-mark8.91d095b1.png";